import dayjs from "dayjs";

import {
  Avatar,
  Box,
  Card,
  Divider,
  IconButton,
  Modal,
  Stack,
  Typography
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  BIGreen,
  BILightGreen,
  BILightGrey,
  BILightRed,
  BILightYellow,
  BIRed,
  BIYellow
} from "../../assets/helpers";
import Loader from "../../common/Loader";
import PictureViewer from "../../common/PictureViewer";
import {
  DELETE_CLIENT_EXPENSES,
  FETCH_CLIENT_EXPENSES,
  FETCH_CLIENT_EXPENSES_HISTORY_V2
} from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import PromptModal from "../../user/common/PromptModal";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";

function ViewClientExpenses({
  open,
  handleClose,
  currentClientExpensesId,
  setViewAddModel,
  viewAddModel
}) {
  const { loginData, multiLanguageData, selectedClientData } = useSelector((state) => state?.main);
  const [currentClientExpenses, setCurrentClientExpenses] = useState([]);
  const [currentClientExpensesHistory, setCurrentClientExpensesHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showAlertModel, setShowAlertModel] = useState(false);

  const [pictureViewerOpen, setPictureViewerOpen] = useState(false);
  const [pictureViewerIndex, setPictureViewerIndex] = useState(0);

  const {
    TEXT_JOB,
    TEXT_DISTANCE,
    TEXT_TAXES,
    TEXT_TIPS,
    TEXT_TOTAL,
    TEXT_PAID_PERSONALLY,
    TEXT_PAID_CARD,
    TEXT_RECEIPTS,
    TEXT_REAJECTED_ON,
    TEXT_APPROVED_ON,
    TEXT_DELETE_EXPENSE_1,
    TEXT_VIEW_DELETE,
    TEXT_DELETE_EXPENSE,
    TEXT_SUBMITTED_ON,
    TEXT_CHOOSE_OPTION,
    TEXT_CANCEL,
    TEXT_SUB_TOTAL,
    TEXT_EXPENSES_REJECTED,
    TEXT_EXPENSES_APPROVED_AND_EDITED
  } = ClientEnglishFallback.ClientViewExpenses(multiLanguageData?.ClientViewExpenses || {});

  useEffect(() => {
    getSingleExpensesData(currentClientExpensesId);
  }, []);

  const getSingleExpensesData = async (currentClientExpensesId) => {
    setIsLoading(true);
    try {
      const obj = {
        PageNr: 1,
        NrOfRecPerPage: 1,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            CreatedBy: loginData?.userInformation?.UserId,
            Id: currentClientExpensesId
          }
        ],
        SortList: [
          {
            FieldName: "dateSubmitted",
            Direction: "DESC"
          }
        ],
        TypeOfObjectReturned: ""
      };
      const clientExpensesResponse = await Postrequestcall(
        FETCH_CLIENT_EXPENSES,
        obj,
        loginData?.accessToken
      );
      if (clientExpensesResponse.status === 200) {
        setCurrentClientExpenses(clientExpensesResponse?.data?.data[0]);
        await getSingleExpensesHistory(currentClientExpensesId);
      }
    } catch (error) {
      console.log("getSingleExpensesData-> Error Getting Expenses Data: ", error);
    }
    setIsLoading(false);
  };
  const getSingleExpensesHistory = async (currentClientExpensesId) => {
    setIsLoading(true);
    try {
      const obj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            clientExpenseId: currentClientExpensesId
          }
        ],
        SortList: [
          {
            FieldName: "Id",
            Direction: "Asc"
          }
        ]
      };

      const clientExpensesHistoryResponse = await Postrequestcall(
        FETCH_CLIENT_EXPENSES_HISTORY_V2,
        obj,
        loginData?.accessToken
      );
      if (clientExpensesHistoryResponse.status === 200) {
        setCurrentClientExpensesHistory(clientExpensesHistoryResponse?.data?.data);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("getSingleExpensesHistory-> Error Getting Expenses History: ", error);
    }
    setIsLoading(false);
  };

  const getColor = (status) => {
    switch (status) {
      case "in Review" && "In Review":
        return BIYellow;
      case "Rejected":
        return BIRed;
      case "Approved":
        return BIGreen;
      default:
        return "black"; // default color for unknown status
    }
  };

  const getBgColor = (status) => {
    switch (status) {
      case "in Review" && "In Review":
        return BILightYellow;
      case "Rejected":
        return BILightRed;
      case "Approved":
        return BILightGreen;
      default:
        return ""; // default color for unknown status
    }
  };

  const handleViewAddModel = () => {
    setViewAddModel(!viewAddModel);
  };

  const handleSaveData = async () => {
    setViewAddModel(!viewAddModel);
  };

  const handleDeleteExpenses = async () => {
    setShowAlertModel(false);
    setIsLoading(true);
    try {
      const obj = {
        UserId: loginData?.userInformation?.UserId,
        returnRecordError: true,
        softDelete: false,
        deleteList: [
          {
            id: currentClientExpensesId
          }
        ]
      };

      const deleteClientExpenseResponse = await Postrequestcall(
        DELETE_CLIENT_EXPENSES,
        obj,
        loginData?.accessToken
      );
      if (deleteClientExpenseResponse.status === 200) {
        handleClose();
      }
    } catch (error) {
      console.log("handleDeleteExpenses-> Error Deleting Client Expenses: ", error);
    }
    handleClose(true);
    setIsLoading(false);
  };

  return (
    <>
      <PictureViewer
        isOpen={pictureViewerOpen}
        onClose={() => setPictureViewerOpen(false)}
        pictures={currentClientExpenses?.expenseReceiptList?.map((img) => {
          return { src: img.fileUrl };
        })}
        viewerIndex={pictureViewerIndex}
      />

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-view-client-support"
        aria-describedby="modal-view-client">
        <>
          {isLoading ? (
            <Loader fullScreen />
          ) : (
            <Box className="client-modal-responsive">
              <Stack spacing={1.2}>
                {currentClientExpenses.status !== "in Review" &&
                  currentClientExpenses.status !== "In Review" &&
                  currentClientExpenses.status !== "" && (
                    <Card
                      className="pagelist-content"
                      // onClick={() => handleShowViewModel(data)}
                      sx={{
                        backgroundColor: getBgColor(currentClientExpenses?.status)
                      }}>
                      <Stack spacing={1}>
                        <Typography
                          sx={{ color: getColor(currentClientExpenses.status),  padding: 1 }}
                          variant="div"
                          >
                          {currentClientExpenses.status === "Rejected" ? (
                            <>{TEXT_EXPENSES_REJECTED}</>
                          ) : currentClientExpenses.status === "Approved" ? (
                            <>{TEXT_EXPENSES_APPROVED_AND_EDITED}</>
                          ) : null}
                        </Typography>
                      </Stack>
                    </Card>
                  )}

                <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction="row">
                  <Typography variant="div" sx={{ color: "grey" }}>
                    {dayjs(currentClientExpenses.dateSubmitted).format("MMMM DD YYYY")}
                  </Typography>
                  <div style={{ display: "flex" }}>
                    {currentClientExpenses.status !== "Approved" && (
                      <IconButton className="view-close" onClick={() => handleViewAddModel()}>
                        <EditIcon
                          style={{
                            color:
                              selectedClientData?.AccentColor !== undefined &&
                              selectedClientData?.AccentColor
                                ? selectedClientData?.AccentColor
                                : BILightGrey
                          }}
                        />
                      </IconButton>
                    )}
                    <IconButton
                      className="view-close"
                      onClick={() => {
                        setShowAlertModel(true);
                      }}>
                      <DeleteIcon style={{ color: BIRed }} />
                    </IconButton>
                    <IconButton className="view-close" onClick={handleClose}>
                      <CloseIcon
                        style={{
                          color:
                            selectedClientData?.AccentColor !== undefined &&
                            selectedClientData?.AccentColor
                              ? selectedClientData?.AccentColor
                              : BILightGrey
                        }}
                      />
                    </IconButton>
                  </div>
                </Stack>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {currentClientExpenses.title}
                </Typography>
                <Typography variant="body1" sx={{ color: "grey" }}>
                  {currentClientExpenses.clientExpenseCode}
                  {" - "}
                  {currentClientExpenses.clientExpenseName}
                </Typography>
                {currentClientExpenses.clientJobCode && (
                  <Stack direction="row" sx={{ justifyContent: "space-between" }}>
                    <Typography variant="body1" sx={{ color: "grey" }}>
                      {TEXT_JOB}
                    </Typography>
                    <Typography variant="body1" sx={{ color: "grey" }}>
                      {TEXT_DISTANCE}
                    </Typography>
                  </Stack>
                )}
                {currentClientExpenses.clientJobCode && (
                  <Stack direction="row" sx={{ justifyContent: "space-between" }}>
                    <Typography variant="body1">
                      {currentClientExpenses.clientJobCode}
                      {" - "}
                      {currentClientExpenses.clientJobName}
                    </Typography>
                    <Typography variant="body1">
                      {currentClientExpenses.mileage} {currentClientExpenses.mileageUnit}
                    </Typography>
                  </Stack>
                )}

                {currentClientExpenses.subTotal !== currentClientExpenses.total &&
                  currentClientExpenses.subTotal !== 0 && (
                    <Stack direction="row" sx={{ justifyContent: "space-between" }}>
                      <Typography variant="body1">{TEXT_SUB_TOTAL}</Typography>
                      <Typography variant="body1" sx={{ color: "grey" }}>
                        {currentClientExpenses.currencySign}
                        {currentClientExpenses.subTotal}
                      </Typography>
                    </Stack>
                  )}
                {currentClientExpenses.tax > 0 && currentClientExpenses.tax !== "" && (
                  <Stack direction="row" sx={{ justifyContent: "space-between" }}>
                    <Typography variant="body1">{TEXT_TAXES}</Typography>
                    <Typography variant="body1" sx={{ color: "grey" }}>
                      {currentClientExpenses.currencySign}
                      {currentClientExpenses.tax}
                    </Typography>
                  </Stack>
                )}
                {currentClientExpenses.tip > 0 && currentClientExpenses.tip !== "" && (
                  <Stack direction="row" sx={{ justifyContent: "space-between" }}>
                    <Typography variant="body1">{TEXT_TIPS}</Typography>
                    <Typography variant="body1" sx={{ color: "grey" }}>
                      {currentClientExpenses.currencySign}
                      {currentClientExpenses.tip}
                    </Typography>
                  </Stack>
                )}

                <Stack direction="row" sx={{ justifyContent: "space-between" }}>
                  <Typography variant="body1">{TEXT_TOTAL}</Typography>
                  <Typography variant="body1">
                    {currentClientExpenses.currencyCode}
                    {currentClientExpenses.currencySign} {currentClientExpenses.total}
                  </Typography>
                </Stack>

                <Stack direction="row" sx={{ justifyContent: "space-between" }}>
                  <Typography variant="body1"></Typography>
                  <Typography variant="body1" sx={{ color: "grey" }}>
                    {currentClientExpenses.paidWith === 1 ? (
                      <>{TEXT_PAID_PERSONALLY}</>
                    ) : currentClientExpenses.paidWith === 2 ? (
                      <>{TEXT_PAID_CARD}</>
                    ) : null}
                  </Typography>
                </Stack>

                <Divider />

                <Typography variant="body1" sx={{ color: "grey" }}>
                  {currentClientExpenses.description}
                </Typography>
                {currentClientExpenses?.expenseReceiptList?.length > 0 && (
                  <Typography variant="body1" sx={{ color: "grey" }}>
                    {" "}
                    {TEXT_RECEIPTS}
                  </Typography>
                )}
                {currentClientExpenses?.expenseReceiptList?.length > 0 && (
                  <Stack
                    direction={"row"}
                    overflow={"scroll"}
                    columnGap={1}
                    sx={{ scrollbarWidth: "none", width: "auto" }}>
                    {currentClientExpenses?.expenseReceiptList?.map((list, index) => (
                      <img
                        onClick={() => {
                          setPictureViewerOpen(true);
                          setPictureViewerIndex(index);
                        }}
                        key={index}
                        src={list.fileUrl}
                        alt="receipt img"
                        height={"90px"}
                        width={"90px"}
                        loading="lazy"
                        style={{ borderRadius: "8px" }}
                      />
                    ))}
                  </Stack>
                )}

                <Typography variant="body1" sx={{ color: "grey" }}>
                  {TEXT_SUBMITTED_ON}{" "}
                  {dayjs(currentClientExpenses.dateSubmitted).format("MMMM DD YYYY h:mm a")}
                </Typography>
                <Stack sx={{ gap: 1 }} >
                  {currentClientExpensesHistory?.length > 0 && (
                    <>
                      {currentClientExpensesHistory?.map((item, index) => (
                        <div key={index}>
                          <Stack direction="row" sx={{ justifyContent: "space-between" }}>
                            <Stack direction="row" sx={{ gap: 1,  alignItems: "center"  }} >
                              <Avatar
                                alt={`${item.statusChangedByUser} + Profile Picture`}
                                src={item.userProfilePicture}
                              />
                              {item.statusChangedByUser}
                            </Stack>
                            <Typography variant="body1" sx={{ color: "grey" }}>
                              {dayjs(item?.statusChangedDate).format("MMMM DD YYYY")}
                            </Typography>
                          </Stack>
                          <Typography variant="body1">{item.statusDescription}</Typography>
                          {currentClientExpenses.status !== "" &&
                            currentClientExpenses.status !== "in Review" &&
                            currentClientExpenses.status !== "In Review" && (
                              <Typography variant="body1" textAlign="center" sx={{ color: "grey" }}>
                                {currentClientExpenses.status === "Rejected" ? (
                                  <>
                                    {TEXT_REAJECTED_ON}{" "}
                                    {dayjs(item.statusChangedDate).format("MMMM DD YYYY h:mm A")}
                                  </>
                                ) : currentClientExpenses.status === "Approved" ? (
                                  <>
                                    {TEXT_APPROVED_ON}{" "}
                                    {dayjs(item.statusChangedDate).format("MMMM DD YYYY h:mm A")}
                                  </>
                                ) : null}
                              </Typography>
                            )}
                        </div>
                      ))}
                    </>
                  )}
                </Stack>
              </Stack>
            </Box>
          )}
        </>
      </Modal>
      {showAlertModel && (
        <PromptModal
          isOpen={showAlertModel}
          onClose={() => setShowAlertModel(false)}
          heading={TEXT_DELETE_EXPENSE_1}
          title={TEXT_DELETE_EXPENSE}
          desc={TEXT_CHOOSE_OPTION}
          redButtonText={TEXT_VIEW_DELETE}
          onRedButtonClick={handleDeleteExpenses}
        />
      )}
    </>
  );
}

export default ViewClientExpenses;

